"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleNumberLocalizer = simpleNumberLocalizer;
exports.default = default_1;
const configure_1 = __importDefault(require("../util/configure"));
const format_number_with_string_1 = __importDefault(require("./format-number-with-string"));
const deconstruct_number_format_1 = require("./deconstruct-number-format");
const defaults = {
    decimal: '.',
    grouping: ','
};
function simpleNumberLocalizer(options) {
    const { decimal, grouping } = Object.assign({}, defaults, options);
    return {
        formats: {
            default: `-#${grouping}##0${decimal}`
        },
        parse(num, _culture, format) {
            let value;
            if (format) {
                const data = (0, deconstruct_number_format_1.deconstructNumberFormat)(format);
                const negative = (data.negativeLeftSymbol && num.indexOf(data.negativeLeftSymbol) !== -1)
                    || (data.negativeRightSymbol && num.indexOf(data.negativeRightSymbol) !== -1);
                num = num
                    .replace(data.negativeLeftSymbol, '')
                    .replace(data.negativeRightSymbol, '')
                    .replace(data.prefix, '')
                    .replace(data.suffix, '');
                const halves = num.split(data.decimalChar);
                if (data.integerSeparator) {
                    halves[0] = halves[0].replace(new RegExp('\\' + data.integerSeparator, 'g'), '');
                }
                if (data.decimalsSeparator) {
                    halves[1] = halves[1].replace(new RegExp('\\' + data.decimalsSeparator, 'g'), '');
                }
                if (halves[1] === '') {
                    halves.pop();
                }
                num = halves.join('.');
                value = +num;
                if (negative) {
                    value = -1 * value;
                }
            }
            else {
                value = parseFloat(num);
            }
            return isNaN(value) ? null : value;
        },
        format(value, format) {
            return (0, format_number_with_string_1.default)(value, format);
        },
        decimalChar(format) {
            var _a;
            return format && ((_a = (0, deconstruct_number_format_1.deconstructNumberFormat)(format)) === null || _a === void 0 ? void 0 : _a.decimalsSeparator) || '.';
        },
        precision(format) {
            const data = (0, deconstruct_number_format_1.deconstructNumberFormat)(format);
            return (data === null || data === void 0 ? void 0 : data.maxRight) !== -1 ? data.maxRight : null;
        }
    };
}
function default_1(options) {
    const localizer = simpleNumberLocalizer(options);
    configure_1.default.setNumberLocalizer(localizer);
    return localizer;
}
//# sourceMappingURL=simple-number-localizer.js.map